import { render, staticRenderFns } from "./MyLeaveDay.vue?vue&type=template&id=bb1e524c&"
import script from "./MyLeaveDay.vue?vue&type=script&lang=js&"
export * from "./MyLeaveDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports